import React from 'react';
import PropTypes from 'prop-types';
import {Header} from '../../../Header';
import {CentrifugeContext} from '../index';
import {ModalFooter} from '../ModalFooter';
import {SectionLeft} from '../SectionLeft';
import {ModalContent} from '../ModalContent';
import {SectionRight} from '../SectionRight';
import {ControlsPanel} from '../ControlsPanel';
import {ContentDescription} from '../ContentDescription';
import {BalanceStatusBlock} from '../BalanceStatusBlock';
import {Modal} from '@learningblocks/shared-components';
import {
  getNewTime,
  isRunningComplete,
  isTimeEqual,
} from '../Microcentrifuge.utils';
import './style.scss';

const COUNT_DOWN_RATE = -1;

export function MicroControlsModal(props) {
  const {isCentrifugeRunnable, isNotRunning} = React.useContext(
    CentrifugeContext
  );

  const [timeLeft, setTimeLeft] = React.useState(props.timeValue);

  React.useEffect(() => {
    if (!isTimeEqual(timeLeft, props.timeValue)) {
      setTimeLeft(props.timeValue);
    }
  }, [props.timeValue]);

  if (props.running) {
    if (isRunningComplete(timeLeft)) {
      setTimeout(() => {
        props.runCentrifuge(false);
      }, props.runInterval);
    } else {
      const newTime = getNewTime(timeLeft, COUNT_DOWN_RATE);
      setTimeout(() => {
        setTimeLeft(newTime);
      }, props.runInterval);
    }
  }

  const onRunCentrifuge = () =>
    isCentrifugeRunnable(() => {
      props.runCentrifuge(true);
    });

  const setRPM = (params) => isNotRunning(() => props.setRPM(params));

  const setTimeValue = (params) =>
    isNotRunning(() => props.setTimeValue(params));

  return (
    <Modal className='controlsModal' isOpen={props.isOpen} size={props.size}>
      <Header
        label='THE MICROCENTRIFUGE (SETTINGS)'
        close={props.onClose}
        size='md'
      />
      <ModalContent className='controlsModal_content'>
        <SectionLeft className='controlsModal_content_left'>
          <ContentDescription
            className='controlsModal_content_left_contentDescription'
            title='Program the microcentrifuge'
            description="Set the time and rotations per minute, then click 'start'. Once it is running, click'Back'"
          />
          <BalanceStatusBlock
            balanced={props.balanced}
            className='controlsModal_content_left_warning'
          />
        </SectionLeft>
        <SectionRight className='controlsModal_content_right'>
          <ControlsPanel
            className='controlsModal_content_right_panel'
            rpmValue={props.rpmValue}
            timeValue={props.timeValue}
            timeLeft={timeLeft}
            setRPM={setRPM}
            setTimeValue={setTimeValue}
            runCentrifuge={onRunCentrifuge}
          />
        </SectionRight>
      </ModalContent>
      <ModalFooter
        text='Back'
        className='controlsModal_footer'
        onClick={props.onClose}
      />
    </Modal>
  );
}

MicroControlsModal.propTypes = {
  /**
   * boolean to set if Microcentrifuge is running
   */
  running: PropTypes.bool,
  /**
   * Boolen to set if modal is displayed
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke to close the modal
   */
  onClose: PropTypes.func,
  /**
   * Boolean to set if the Microcentrifuge tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
  /**
   * Countdown interval for microcentrifuge rundown timer
   */
  runInterval: PropTypes.number,
};

MicroControlsModal.defaultProps = {
  showClose: true,
  size: 'md',
};
